import React from "react"

interface CashFlowMetricsLoadingProps {
  isVisible: boolean
}

export const CashFlowMetricsLoading: React.FC<CashFlowMetricsLoadingProps> = ({ isVisible }) => {
  if (!isVisible) return null

  return (
    <div className="space-y-4" aria-busy="true" aria-live="polite">
      <div className="animate-pulse rounded-2xl border border-slate-200 bg-white p-5 motion-reduce:animate-none">
        <div className="h-7 w-56 rounded-lg bg-slate-200" />
        <div className="mt-3 h-4 w-full max-w-xl rounded bg-slate-100" />
        <div className="mt-2 h-4 w-3/4 max-w-md rounded bg-slate-100" />
      </div>

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4">
        {Array.from({ length: 4 }, (_, index) => (
          <div
            key={index}
            className="h-32 animate-pulse rounded-2xl border border-slate-200 bg-white p-4 motion-reduce:animate-none"
          >
            <div className="h-3 w-24 rounded bg-slate-200" />
            <div className="mt-5 h-7 w-36 rounded bg-slate-200" />
            <div className="mt-3 h-3 w-28 rounded bg-slate-100" />
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 gap-4 xl:grid-cols-2">
        {Array.from({ length: 2 }, (_, index) => (
          <div
            key={index}
            className="h-80 animate-pulse rounded-2xl border border-slate-200 bg-white p-5 motion-reduce:animate-none"
          >
            <div className="h-4 w-48 rounded bg-slate-200" />
            <div className="mt-6 h-60 rounded-xl bg-slate-100" />
          </div>
        ))}
      </div>
    </div>
  )
}
